import React from 'react';
import { SkeletonItem } from '@atlaskit/menu';
import { N20A } from '@atlaskit/theme/colors';
import { ICON_SIZE } from './utils';
const cssFn = () => {
  return {
    '&::before': {
      backgroundColor: `var(--ds-skeleton, ${N20A})`,
      borderRadius: '100%',
      flexShrink: 0,
      content: '""',
      marginLeft: 0,
      marginRight: "var(--ds-space-150, 12px)",
      width: ICON_SIZE,
      height: ICON_SIZE
    }
  };
};
export default function LoadingSkeletonItem() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    React.createElement(SkeletonItem, {
      hasAvatar: true,
      cssFn: cssFn,
      testId: "people-menu-skeleton-item"
    })
  );
}